export default {
  authorId: 1,
  feed: [
    {
      id: 0,
      author: 'Person',
      contents: 'hi there',
      date: '16:30'
    },
    {
      id: 1,
      author: 'Me',
      contents: 'hello',
      date: '16:30'
    },
    {
      id: 1,
      author: 'Me',
      contents: 'lol',
      date: '16:31'
    }
  ]
}
